import React from 'react'
import Children from './Children.jsx'

export const UseField = ({ children }) =>
  <Children>
    {children}
  </Children>

export default UseField